import DefaultValidation from '@/services/validations/DefaultValidation';
import Message from '@/models/Message';

export default class VenProdutoValidation extends DefaultValidation {

    constructor(msgs) {
        super(msgs);
    }

    /* ABA UNIDADE DE MEDIDA */
    validateNovaUnMedida (um) {
        let valid = true;

        if (um.selected == null) {
            console.error('Validação falhou na aba UNIDADE DE MEDIDA: Não foi selecionado uma unidade de medida.');

            this.showMessage(new Message("error", 'msg-erro-add-un-medida-vazio', true));

            valid = false;
        }
        
        if (um.selected.percentualreajuste == '' || isNaN(um.selected.percentualreajuste) || um.selected.percentualreajuste == null) {
            console.error(`Validação falhou na aba UNIDADE DE MEDIDA: Percentual de reajuste inválido: [${um.selected.percentualreajuste}].`);

            this.showMessage(new Message("error", 'msg-erro-add-un-medida-perc-reajuste', true));

            valid = false;
        }

        if (um.selected.fatorconversaoestoque == '' || isNaN(um.selected.fatorconversaoestoque) || um.selected.fatorconversaoestoque == null) {
            console.error(`Validação falhou na aba UNIDADE DE MEDIDA: Fator de conversão inválido: [${um.selected.fatorconversaoestoque}].`);

            this.showMessage(new Message("error", 'msg-erro-add-un-medida-fator-conv', true));

            valid = false;
        }

        return valid;
    }

    /* ABA CONFIGURAÇÕES */
    validateNovoDesconto (dq) {
        let valid = true;

        if (isNaN(dq.qtdeinicio) || dq.qtdeinicio === '') {
            console.error(`Validação falhou na aba CONFIGURAÇÕES: Quantidade inicial inválida: [${dq.qtdeinicio}].`);
            this.showMessage(new Message("error", 'msg-erro-desc-qtd-ini', true));
            valid = false;
        } else if (parseFloat(dq.qtdeinicio) < 0) {
            console.error(`Validação falhou na aba CONFIGURAÇÕES: Quantidade inicial menor que zero: [${dq.qtdeinicio}].`);
            this.showMessage(new Message("error", 'msg-erro-desc-qtd-maior-zero', true));
            valid = false;
        }

        if (isNaN(dq.qtdefim) || dq.qtdefim === '') {
            console.error(`Validação falhou na aba CONFIGURAÇÕES: Quantidade inicial inválida: [${dq.qtdefim}].`);
            this.showMessage(new Message("error", 'msg-erro-desc-qtd-fim', true));
            valid = false;
        } else if (parseFloat(dq.qtdefim) < 0) {
            console.error(`Validação falhou na aba CONFIGURAÇÕES: Quantidade inicial menor que zero: [${dq.qtdefim}].`);
            this.showMessage(new Message("error", 'msg-erro-desc-qtd-maior-zero', true));
            valid = false;
        }

        if (isNaN(dq.diferenca) || dq.diferenca === '') {
            console.error(`Validação falhou na aba CONFIGURAÇÕES: Reajuste inválido: [${dq.diferenca}].`);
            this.showMessage(new Message("error", 'msg-erro-desc-reajuste', true));
            valid = false;
        }

        if (!isNaN(dq.qtdeinicio) && !isNaN(dq.qtdefim) && (parseFloat(dq.qtdeinicio) >= parseFloat(dq.qtdefim))) {
            console.error(`Validação falhou na aba CONFIGURAÇÕES: Quantidade inicial maior/igual que a final: [${dq.qtdeinicio} >= ${dq.qtdefim}].`);
            this.showMessage(new Message("error", 'msg-erro-desc-qtd-ini-fim', true));
            valid = false;
        }
        
        if ( dq.empresa == null ) {
            console.error(`Validação falhou na aba CONFIGURAÇÕES: Nenhuma empresa selecionada.`);
            this.showMessage(new Message("error", 'msg-erro-desc-empresa', true));
            valid = false;
        }

        if (dq.tabpreco == null) {
            console.error(`Validação falhou na aba CONFIGURAÇÕES: Não há tabela de preço.`);
            this.showMessage(new Message("error", 'msg-erro-desc-qtd-tabpreco', true));
            valid = false;
        }

        return valid;
    }

    validateNovoMultiplicador (m) {        
        let valid = true;

        if (isNaN(m.venda) || m.venda === '') {
            console.error(`Validação falhou na aba CONFIGURAÇÕES: Multiplicador de venda inválido: [${m.venda}].`);
            this.showMessage(new Message("error", 'msg-erro-mult-venda', true));
            valid = false;
        } else if (parseFloat(m.venda) < 0) {
            console.error(`Validação falhou na aba CONFIGURAÇÕES: Multiplicador de venda menor que zero: [${m.venda}].`);
            this.showMessage(new Message("error", 'msg-erro-mult-venda-maior-zero', true));
            valid = false;
        }

        if (isNaN(m.troca) || m.troca === '') {
            console.error(`Validação falhou na aba CONFIGURAÇÕES: Multiplicador de troca inválido: [${m.troca}].`);
            this.showMessage(new Message("error", 'msg-erro-mult-troca', true));
            valid = false;
        } else if (parseFloat(m.troca) < 0) {
            console.error(`Validação falhou na aba CONFIGURAÇÕES: Multiplicador de troca menor que zero: [${m.troca}].`);
            this.showMessage(new Message("error", 'msg-erro-mult-troca-maior-zero', true));
            valid = false;
        }

        return valid;
    }

    validateNovaConfig (config) {
        let valid = true;

        if (isNaN(config.porctroca) || config.porctroca === '') {
            console.error(`Validação falhou na aba CONFIGURAÇÕES: Porcentagem de troca inválida: [${config.porctroca}].`);
            this.showMessage(new Message("error", 'msg-erro-config-porctroca', true));
            valid = false;
        } else if (parseFloat(config.porctroca) < 0) {
            console.error(`Validação falhou na aba CONFIGURAÇÕES: Porcentagem de troca menor que zero: [${config.porctroca}].`);
            this.showMessage(new Message("error", 'msg-erro-config-porctroca-maior-zero', true));
            valid = false;
        }

        return valid;
    }
}